export default __webpack_public_path__ + "static/media/search.518d9536.svg";